export const MEDIA_BREAKPOINTS = Object.freeze({
  ms: 320,
  mm: 375,
  ml: 425,
  xs: 576,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  _2xl: 1536,
});
